import { useRef } from "react";
import { Camera, ImageOff } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, itemImg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const uploadItemImage = async (item, file) => {
  const fd = new FormData();
  fd.append("file", file);
  await api.post(`/items/${item.id}/image`, fd);
};

export const ItemImageButton = ({ item, onUploaded, label, variant = "secondary", className = "" }) => {
  const ref = useRef();
  const pick = async (e) => {
    const f = e.target.files[0];
    if (!f) return;
    try {
      await uploadItemImage(item, f);
      toast.success("Image uploaded");
      onUploaded();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      ref.current.value = "";
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`item-image-input-${item.sku}`} />
      <Button type="button" size="sm" variant={variant} className={className} onClick={(e) => { e.stopPropagation(); ref.current.click(); }} data-testid={`item-image-btn-${item.sku}`}>
        <Camera className="h-4 w-4" />{label && <span className="ml-1">{label}</span>}
      </Button>
    </>
  );
};

export const ItemThumb = ({ item, className = "" }) => {
  const src = itemImg(item);
  return src ? (
    <img src={src} alt={item.name} loading="lazy" className={`object-contain ${className}`} />
  ) : (
    <div className={`grid place-items-center bg-slate-100 text-slate-300 ${className}`}><ImageOff className="h-8 w-8" /></div>
  );
};
